import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Input from './Input';
import colors from '../../../styling/colors';

const InputContainer = styled.div`
  position: relative;
  margin: 0 0 1rem;
  width: 100%;
`;

const StyledInput = styled(Input)`
  margin: 0;
  padding: 0 4.5rem 0 1rem;
`;

const ShowHideToggle = styled.div`
  display: inline-block;
  position: absolute;
  top: 0;
  right: 0;
  height: 2.75rem;
  line-height: 2.75rem;
  text-align: center;
  vertical-align: middle;
  color: ${colors('silver')};
  width: 4.5rem;
  cursor: pointer;
  font-size: 12px;
  letter-spacing: 2px;
  font-weight: bold;
  text-transform: uppercase;
  text-selection: none;
`;

export default class PasswordInput extends Component {
  static propTypes = {
    error: PropTypes.bool,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    value: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.state = {
      showPassword: false,
    };
  }

  toggleShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  render() {
    const { className, error, onChange, placeholder, value } = this.props;
    const { showPassword } = this.state;

    return (
      <InputContainer className={className}>
        <StyledInput
          error={error}
          onChange={onChange}
          placeholder={placeholder}
          type={showPassword ? 'text' : 'password'}
          value={value}
          autoCorrect="off"
          autoCapitalize="none"
        />
        <ShowHideToggle onClick={this.toggleShowPassword}>
          {showPassword ? 'hide' : 'show'}
        </ShowHideToggle>
      </InputContainer>
    );
  }
}
